export default function Autoridade() {
  return (
    <section className="py-16 md:py-24 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Tradição de Mestre, Olhar de Designer.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-10 md:gap-12 items-center">
          <div className="space-y-6">
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              Em uma metrópole que não para como São Paulo, a Realeza Tapeçaria & Design se destaca pelo cuidado artesanal e pela atenção minuciosa aos detalhes. Com mais de três décadas de história, consolidamos nossa marca como referência no mercado paulistano de decoração de alto padrão.
            </p>

            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              Não apenas reformamos móveis; nós restauramos o valor afetivo e a estética de cada peça. Nossa equipe de mestres tapeceiros domina técnicas seculares, garantindo que cada costura, enchimento e acabamento sejam executados com a precisão que seu imóvel merece. Seja um apartamento nos Jardins ou uma residência em Alphaville, levamos a sofisticação da Realeza até você.
            </p>

            <div className="flex items-center justify-around sm:justify-start sm:space-x-8 pt-6">
              <div className="text-center">
                <div className="text-4xl sm:text-5xl font-bold text-emerald-600 mb-2">35+</div>
                <div className="text-xs sm:text-sm text-gray-600 font-medium">Anos de Tradição</div>
              </div>
              <div className="text-center">
                <div className="text-4xl sm:text-5xl font-bold text-emerald-600 mb-2">5000+</div>
                <div className="text-xs sm:text-sm text-gray-600 font-medium">Projetos Realizados</div>
              </div>
              <div className="text-center">
                <div className="text-4xl sm:text-5xl font-bold text-emerald-600 mb-2">100%</div>
                <div className="text-xs sm:text-sm text-gray-600 font-medium">Satisfação</div>
              </div>
            </div>
          </div>

          <div className="relative mt-6 md:mt-0">
            <div className="relative rounded-lg overflow-hidden shadow-2xl hover:shadow-emerald-500/20 transition-all duration-500 hover:scale-105">
              <div className="w-full h-72 sm:h-96">
                <img 
                  src="https://public.readdy.ai/ai/img_res/04b5d1bd09842eca2b020fb90a3ecf03.jpg"
                  alt="Mestre tapeceiro trabalhando"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="hidden md:block absolute -bottom-6 -right-6 w-32 h-32 bg-emerald-600 rounded-lg opacity-20"></div>
            <div className="hidden md:block absolute -top-6 -left-6 w-32 h-32 bg-emerald-600 rounded-lg opacity-20"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
